import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_NewsDetailCard = _resolveComponent("NewsDetailCard")
  const _component_RolesCard = _resolveComponent("RolesCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.newsManagement.detailTitle')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.handleSubmit,
          disabled: _ctx.invalid
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm,
          "data-test": "close-button"
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_NewsDetailCard, {
        selectedNews: _ctx.selectedNews,
        onFieldChanged: _ctx.onFieldChange
      }, null, 8, ["selectedNews", "onFieldChanged"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_RolesCard, {
        categoryList: _ctx.roleList,
        selected: _ctx.selectedNews.roles,
        onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedRoles($event)))
      }, null, 8, ["categoryList", "selected"])
    ])
  ], 64))
}